import './phone-number.less';

import React from 'react';
import {normalizePhone} from '../../utils/normalize-phone';
import {CustomIcon} from './custom-icon';
import {withRouter} from 'react-router-dom';
import {generateSendSmsLink} from '../../utils/generate-send-sms-link';


@withRouter
export class PhoneNumber extends React.Component {
  render() {
    let { phone, showSendSms } = this.props;

    if (showSendSms !== false) {
      showSendSms = true;
    }

    if (!phone) {
      return '';
    }

    phone = normalizePhone(phone);

    const href = `tel:${phone}`;
    return (
      <div className="phone-number-view">
        <a className="phone-number" href={href} style={{ marginRight: 12 }}>
          {phone}
        </a>
        { showSendSms && <CustomIcon icon={'sms'} onClick={() => this.props.history.push(generateSendSmsLink([phone]))}/> }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/phone-number.js